module.exports = __webpack_public_path__ + "static/media/16UNODC16.bfec1e94.jpg";